import axios from "axios";
import { Helmet } from "react-helmet";
import { RingLoader } from "react-spinners";
import { useState, useEffect } from "react";
// import { alert_error, alert_success } from '../AppContext.js'
// import { type } from '@testing-library/user-event/dist/type/index.js'
import classNames from "classnames";
import TableCard from "./TableCard";
import { useNavigate } from 'react-router-dom';
import AdSense from 'react-adsense';
import { Cookies } from "../index.js";
import { alert_error, alert_success } from "../AppContext.js";
import Select from "react-select";
import ChangeHistory from "./ChangeHistory";
import Doithe_pay_home from "./Doithe_pay_home";
import Coin_seller_edit from '../wallet/e_commerce/coin_seller_edit.jsx';
import Bannerprofile from '../shop/ads/Bannerprofile.jsx';
const dulieutaikhoan = async () => {

  try {
    const apikey = Cookies.get("apikey");
    const response = await axios.post("https://hust.media/api/account.php", {
      apikey: apikey,
      chedo: "laythongtin",
      dulieu: "doithe",
    });
    // Xử lý dữ liệu trả về ở đây
    return response.data;
  } catch (error) {
    // Xử lý lỗi ở đây
    console.log(error);
  }
};

const typeCard = [
  { value: "VIETTEL", label: "VIETTEL" },
  { value: "VINAPHONE", label: "VINAPHONE" },
  { value: "MOBIFONE", label: "MOBIFONE" },
  { value: "VNMOBI", label: "VNMOBI" },
  { value: "ZING", label: "ZING" },
  { value: "VCOIN", label: "VCOIN" },
  { value: "GARENA", label: "GARENA" },
  { value: "GATE", label: "GATE" },
];
const priceCard = [
  { value: "10000", label: "10.000 (10k)" },
  { value: "20000", label: "20.000 (20k)" },
  { value: "30000", label: "30.000 (30k)" },
  { value: "50000", label: "50.000 (50k)" },
  { value: "100000", label: "100.000 (100k)" },
  { value: "200000", label: "200.000 (200k)" },
  { value: "300000", label: "300.000 (300k)" },
  { value: "500000", label: "500.000 (0.5m)" },
  { value: "1000000", label: "1.000.000 (1m)" },
  { value: "2000000", label: "2.000.000 (2m)" },
  { value: "5000000", label: "5.000.000 (5m)" },
];
function Doithe() {
  const navigate = useNavigate();
  const [pin, setpin] = useState("");
  const [seri, setseri] = useState("");
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
  const [loading, setLoading] = useState(true);
  const [bangsale, setbangsale] = useState(false);
  const [ratethe, setratethe] = useState(false);
  const [accountInfo, setAccountInfo] = useState({});
  const [type, setType] = useState("VIETTEL");
  const [lever, setLever] = useState("Newbie");
  const [saleRate, setSaleRate] = useState(0);
  const [selectedTypeOption, setSelectedTypeOption] = useState("VIETTEL");
  const [selectedPriceOption, setSelectedPriceOption] = useState("10000");
  const [typeOpen, setTypeOpen] = useState(true);
  const [priceOpen, setPriceOpen] = useState(false);
  const [userOption, setUserOption] = useState("changeCard");

  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder("đặt tiếp luôn nào");
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    } else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != "") {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  }
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get("apikey");
    event.preventDefault();
    const data = {
      key: apikey,
      loaithe: selectedTypeOption.value,
      menhgia: selectedPriceOption.value,
      chedo: "doithe",
      pin: pin,
      seri: seri,
    };
    const dsfsdfsdfsf = "https://hust.media/api/topup_card/doithepost.php";
    setnutxuly(1);
    setnutorder("Please wait a moment 😊");
    if (!pin || !seri) {
      alert_error("Please điền đầy đủ thông tin");
      setnutxuly(0);
      setnutorder("điền đủ thông tin");
      return;
    }
    axios
      .post(dsfsdfsdfsf, data)
      .then((response) => testFunction(response))
      .catch((error) => alert_error(error));
  }
  const daily = async () => {
    axios
      .get("https://hust.media/api/topup_card/rategiam.php")
      .then((response) => {
        setbangsale(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dulieuratethe = async () => {
    axios
      .get("https://hust.media/api/topup_card/ratethe.php")
      .then((response) => {
        setratethe(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Thiết lập vòng lặp
  useEffect(() => {
    const urlok = window.location.href; // Lấy URL hiện tại
    const uriok = urlok.split('/').pop().split('?')[0].split('#')[0]; // Lấy phần URI cuối cùng, bỏ qua query string và fragment
    
    if (uriok == 'rate') {
      setUserOption("boardPrice");
    }
    else if (uriok == 'history') {
      setUserOption("changeHistory");
    } else if (uriok == 'pay_edit') {
      setUserOption("pay_edit");
    }
    else if (uriok == 'pay_home') {
      setUserOption("pay_home");
    }
    setLoading(true);
    dulieuratethe();
    daily();
    dulieutaikhoan()
      .then((data) => {
        setAccountInfo(data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleProcess = (type, value) => {
    let rateCard = 0;
    ratethe &&
      ratethe.forEach((item) => {
        // console.log(item);
        if (item.telco === type && item.value === value) {
          console.log("fees", item.fees);
          rateCard =
            Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
            100;
        }
      });
    return value - (value * rateCard) / 100;
  };

  const handleDiscount = (type, value) => {
    let rateCard = 0;
    ratethe &&
      ratethe.forEach((item) => {
        if (item.telco === type && item.value === value) {
          rateCard =
            Math.round((item.fees / (100 + Number(saleRate))) * 100 * 100) /
            100;
        }
      });
    return rateCard;
  };
  return (
    <>
      <div className="max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block' }}
            format='horizontal'
            responsive='false'
          /></div>
      </div>
      <div className="flex justify-center mt-0 gap-2">
        <div
          className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 ${classNames(
            {
              "border-blue-600": userOption === "changeCard",
            }
          )}`}
          onClick={() => {
            setUserOption("changeCard");
            navigate('/shop/doithe');
          }}
        >
          Đổi thẻ cào
        </div>
        <div
          className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 ${classNames(
            {
              "border-blue-600": userOption === "boardPrice",
            }
          )}`}
          onClick={() => {
            setUserOption("boardPrice");
            navigate('/shop/doithe/rate');
          }}
        >
          Rate đổi thẻ
        </div>
        <div
          className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 ${classNames(
            {
              "border-blue-600": userOption === "changeHistory",
            }
          )}`}
          onClick={() => {
            setUserOption("changeHistory");
            navigate('/shop/doithe/history');
          }}
        >
          Nhật ký đổi
        </div>
        <div
          className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 ${classNames({
            "border-blue-600": userOption === "pay_home" || userOption === "pay_edit",
          })}`}
          onClick={() => {
            setUserOption("pay_home");
            navigate('/shop/doithe/pay_home');
          }}
        >
          {/* Nội dung ở đây */}
          Nhận vnđ coin
        </div>
      </div >
      <div className="py-4 px-3">
        {loading ? (
          <div className="flex justify-center items-center">
            <RingLoader size={80} color="#0000ff" loading={loading} />{" "}
          </div>
        ) : (
          !loading && (
            <div className="bg-[#f5f6fa] rounded-lg shadow-md border-blue-400 border-2 p-2">
              {/* {userOption === 'changeCard' && (
                            <div className='p-2 bg-white lg:max-w-lg rounded-md'>
                                <h1 className='text-xl font-bold mb-3'>Thông tin tài khoản</h1>
                                <p className='text-base'>username: {accountInfo.username}</p>
                                <p className='text-base'>Mã cấp độ: {accountInfo.codelevel}</p>
                                <p className='text-base'>Tên cấp độ: {accountInfo.namelevel}</p>
                                <p className='text-base'>Rate giảm: {accountInfo.rategiam}</p>
                            </div>
                        )} */}
              {ratethe && (<ChangeHistory userOption={userOption} />)}
              <TableCard
                setLever={setLever}
                setSaleRate={setSaleRate}
                lever={lever}
                bangsale={bangsale}
                userOption={userOption}
                saleRate={saleRate}
                ratethe={ratethe}
                type={type}
                setType={setType}
              />
              {userOption === "changeCard" && (
                <form>
                  <Helmet>
                    <title>Đổi Thẻ Cào Thành Tiền Mặt Miễn Phí Không Chiết Khấu</title>
                    <meta name="description" content="Đổi thẻ cào thành tiền mặt chiết khấu cực thấp, không qua trung gian. Tốc độ sử lý cực nhanh 5s/thẻ, rút tiền miễn phí, bảo mật 2 lớp, hỗ trợ khách hàng 24/7." />
                    <meta name="keywords" content="đổi thẻ cào thành tiền mặt, doi the cao thanh tiên mat, đổi thẻ cào sang tiền mặt, đổi thẻ cào, đổi thẻ game, đổi thẻ cào, gạch thẻ cào" />
                    <meta name="copyright" content="ĐỔI THẺ CÀO THÀNH TIỀN MẶT" />
                    <meta name="author" content="ĐỔI THẺ CÀO THÀNH TIỀN MẶT - Hệ thống đổi thẻ cào thành tiền mặt uy tín nhất Việt Nam" />

                    <meta property="og:title" content="Đổi Thẻ Cào Thành Tiền Mặt Chiết Khấu Thấp Nhất Thị Trường" />
                    <meta property="og:site_name" content="ĐỔI THẺ CÀO THÀNH TIỀN MẶT" />
                    <meta property="og:url" content="https://hust.media/" />
                    <meta property="og:description" content="Đổi thẻ cào thành tiền mặt chiết khấu cực thấp, không qua trung gian. Tốc độ sử lý cực nhanh 5s/thẻ, rút tiền miễn phí, bảo mật 2 lớp, hỗ trợ khách hàng 24/7." />
                  </Helmet>
                  <div className="p-2 bg-white">
                    <div className="text-xs lg:text-base">Chọn nhà mạng</div>
                    <Select
                      className="text-xs lg:text-base"
                      defaultValue={selectedTypeOption}
                      onChange={setSelectedTypeOption}
                      options={typeCard}
                      menuIsOpen={typeOpen}
                      isSearchable={false}
                      onMenuOpen={() => setTypeOpen(true)}
                      onMenuClose={() => {
                        setTypeOpen(false);
                        setPriceOpen(true);
                      }}
                    />
                    <div className="text-xs lg:text-base">Chọn mệnh giá</div>
                    <Select
                      className="text-xs lg:text-base"
                      defaultValue={selectedPriceOption}
                      onChange={setSelectedPriceOption}
                      isSearchable={false}
                      options={priceCard}
                      menuIsOpen={priceOpen}
                      onMenuOpen={() => setPriceOpen(true)}
                      onMenuClose={() => setPriceOpen(false)}
                    />
                    <div className="text-xs my-1 lg:text-base">
                      <label
                        htmlFor="seri-input"
                        className="inline-block font-bold mb-1"
                      >
                        Seri thẻ cào:
                        <small className="inline-block text-gray-500 ">
                          💳 hiện sẵn ở mỗi thẻ
                        </small>
                      </label>
                      <input
                        id="seri-input"
                        type="text"
                        className="block w-full text-base px-3 py-2 outline-pink-400 font-bold text-green-500  border border-pink-400 rounded-md placeholder:text-xs"
                        placeholder="Nhập số seri"
                        onChange={(e) => setseri(e.target.value)}
                      />

                    </div>

                    <div className="text-xs lg:text-base">
                      <label
                        htmlFor="pin-input"
                        className="inline-block font-bold mb-1"
                      >
                        Mã thẻ cào:<small className="inline-block text-gray-500 ">
                          🔑 hiện ra khi cào thẻ
                        </small>
                      </label>
                      <input
                        id="pin-input"
                        type="text"
                        className="block w-full text-base px-3 py-2 outline-pink-400 
                        font-bold text-green-500 border border-pink-400 rounded-md placeholder:text-xs"
                        placeholder="Nhập số mã"
                        onChange={(e) => setpin(e.target.value)}
                      />

                    </div>

                    <button disabled={nutxuly == 1}
                      onClick={handleSubmit}

                      className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                    >
                      <div className="flex items-center justify-between flex-1">
                        {nutxuly == 1 && (
                          <div className="spinner-border" role="status"></div>
                        )}

                        <span className="text-lg font-medium text-white">
                          {nutorder}{" "}
                        </span>
                        <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                      </div>
                    </button>
                  </div>{" "}
                </form>
              )}
              {userOption === "changeCard" && (


                <div className="relative mt-2 p-2 rounded-md border-2 border-pink-500 bg-white">

                  <div className="text-xs lg:text-base">
                    🌟 Số Coins nhận:{" "}
                    {handleProcess(
                      selectedTypeOption.value,
                      Number(selectedPriceOption.value)
                    )}
                  </div>
                  <div className="text-xs lg:text-base">
                    🏷️ Giá trị thẻ: {selectedPriceOption.label}
                  </div>
                  <div className="text-xs lg:text-base">
                    🎁 Chiết khấu:{" "}
                    {handleDiscount(
                      selectedTypeOption.value,
                      Number(selectedPriceOption.value)
                    )}
                    %<span className="ml-2">&#10132;</span>
                    <span className="text-gray-600">
                      Tặng 1 ưu đãi miễn phí cho lần tiếp theo
                    </span>
                  </div>
                  <div className="absolute top-0 left-0 w-full h-full rounded-md border-2 border-pink-500 opacity-0 transition-opacity duration-300 hover:opacity-100"></div>
                </div>
              )}
              {userOption === "pay_home" && (
                <Doithe_pay_home setUserOption={setUserOption} />
              )}
              {userOption === "pay_edit" && (
                <Coin_seller_edit />
              )}
            </div>
          )
        )}
      </div>

    </>
  );
}

export default Doithe;
